import { health } from '@/api';
import * as types from './mutationTypes';

export default {
    async loadModules({ dispatch }) {
        const getClient = dispatch('client/get');
        const getClientContext = dispatch('clientContext/getAll');
        // TODO: Maybe move this inside of the AppSideNav component if the
        // data is not global.
        const getActivatedModules = dispatch('activatedCEModules/getAll');

        return Promise.all([
            getClient,
            getClientContext,
            getActivatedModules
        ]).catch(err => Promise.reject(err));
    },

    async appInitialise({ getters, dispatch, commit }, version) {
        commit(types.APP_SET_VERSION, version);

        await dispatch('session/initialize');

        // If the user is logged in populate the vuex store
        // if (getters['session/isAuthenticated']) {
        //     await dispatch('loadModules');
        // }

        commit(types.APP_SET_INITIALISED);
        const response = await health.getApiVersion();
        if (typeof response.data.version !== 'undefined') {
            commit(types.APP_SET_API_VERSION, response.data.version);
        }

        const ceVersionResp = await health.getContenEngineVersion();
        if (typeof ceVersionResp.data.version !== 'undefined') {
            commit(types.APP_SET_CE_VERSION, ceVersionResp.data.version);
        }
    },
};



// WEBPACK FOOTER //
// ./src/store/actions.js